module.exports = __webpack_public_path__ + "img/appltCourse-img22.831ea124.png";